export default [
  {
    title: 'Descritor',
    field: 'descriptor_code',
    editable: 'never',
    width: 200,
    headerStyle: {
      textAlign: 'left',
      paddingLeft: 50
    },
    cellStyle: {
      textAlign: 'left',
      paddingLeft: 50
    }
  },
  {
    title: 'Descrição',
    field: 'descriptor_description',
    editable: 'never',
    width: 600,
    headerStyle: {
      textAlign: 'left'
    },
    cellStyle: {
      textAlign: 'left'
    },
  }
];

